import ServicesGroup from './src/ServicesGroup/ServicesGroup.css';
import ServiceAggregation from './src/ServiceAggregation.css';
export default {
    ServicesGroup,
    ServiceAggregation
};
